import React from 'react';
import { Box, Typography, Card, Grid2 } from '@mui/material';
import GradeMetricsCard from './GradeMetricsCard/GradeMetricsCard';
import { useTranslation } from 'react-i18next';
import { useGradingHistory } from './GradingHistoryContext';


const headerSx = {
  fontFamily: 'Montserrat',
  fontWeight: 600,
  fontSize: '12px',
  lineHeight: '145%',
  letterSpacing: 0,
  color: '#353535',
  textTransform: 'uppercase',
};


const developmentAnnotationPNSx = {
  width: '100%',
  height: '100%',
  borderRadius: 4,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#fff',
  background: 'linear-gradient(230.15deg, rgba(240, 154, 89, 0.16) 0%, rgba(255, 255, 255, 1) 50%)',
  border : '1px solid rgba(240, 154, 89, 0.16)'
};

const developmentAnnotationCleavageSx={
  width: '100%',
  height: '100%',
  borderRadius: 4,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#fff',
  background: 'linear-gradient(230.15deg, rgba(165, 65, 223, 0.16) 0%, rgba(255, 255, 255, 0.16) 50%)',
  border : '1px solid rgba(165, 65, 223, 0.16)'
};


const developmentAnnotationBlastocystSx={
  width: '100%',
  height: '100%',
  borderRadius: 4,
  display: 'flex',
  flexDirection: 'column',
  backgroundColor: '#fff',
  background: 'linear-gradient(230.15deg, rgba(57, 159, 197, 0.16) 0%, rgba(255, 255, 255, 0.16) 50%)',
  border : '1px solid rgba(57, 159, 197, 0.16)'
};


const cardSx ={
  padding: 2,
  borderRadius: 4,
  backgroundColor: '#FFFFFF',
  border: '1px solid #F0F0F0',
  position: 'relative',
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  // height: '100%'
};

const DevlopmentAnotation: React.FC = () => {
  const { t: tAiGrading } = useTranslation('aiGrading_config');


  const { selectedEmbryoResult } = useGradingHistory();

  return (
    <Card
      elevation={0}
      sx={cardSx}
    >
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Typography sx={headerSx}>
          {tAiGrading('developmentAnnotation')}
        </Typography>
      </Box>

      {/* Section */}
      <Grid2 container spacing={2} size={12} sx={{ alignItems: 'stretch' }} flex={1}>
       
        <Grid2 size={4}>
          <GradeMetricsCard
            metrics={selectedEmbryoResult?.development_annotations1}
            sx={developmentAnnotationPNSx}
          />
        </Grid2>

       
        <Grid2 size={4}>
          <GradeMetricsCard
            metrics={selectedEmbryoResult?.development_annotations2}
            sx={developmentAnnotationCleavageSx}
          />
        </Grid2>

        <Grid2 size={4}>
          <GradeMetricsCard
            metrics={selectedEmbryoResult?.development_annotations3}
            sx={developmentAnnotationBlastocystSx}
          />
        </Grid2>
      </Grid2>
    </Card>
  );
};

export default DevlopmentAnotation;